import { lazy, Suspense, useState } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Login from './shared/components/Login';
import UserEdit from './modules/admin/pages/user/UserEdit';
import AddBase from './modules/admin/pages/AddBase';
import Bases from './modules/admin/pages/Bases';
import EditBase from './modules/admin/pages/EditBase';
import Layout from './modules/admin/layouts/AdminLayout'; // Your layout component
import AddSupervisor from './modules/admin/pages/AddSupervisor';
 import FastExcelExport from './modules/admin/pages/export/SimpleExport';
// import ExcelImport from './modules/admin/pages/import/ExcelImport';
import ExcelImport from './modules/admin/pages/import/ExcelImport';
import UserLog from '../src/modules/admin/pages/LoginLogs';
  // Lazy load modules for code splitting
const AdminLayout = lazy(() => import('./modules/admin/layouts/AdminLayout'));
const AdminRoutes = lazy(() => import('./modules/admin/routes/AdminRoutes'));
const ChawderLayout = lazy(() => import('./modules/chawder/layouts/ChawderLayout'));
const ChawderRoutes = lazy(() => import('./modules/chawder/routes/ChawderRoutes'));

// Loading component
const Loading = () => (
  <div className="loading-container">
    <div className="loading-spinner">Loading...</div>
  </div>
);

function AppRouter() {
  const [currentView, setCurrentView] = useState('admin'); // admin, chawder, or login

  return (
    <Suspense fallback={<Loading />}>
      <Routes>
        <Route path="/" element={<Navigate to="/admin" replace />} />
        {/* admin/user */}

        <Route element={<Layout />}>
        <Route path="/admin/user/edit/:id" element={<UserEdit/>} />
        <Route path="/admin/user/add" element={<AddSupervisor/>} />
        </Route>
        {/* // base route */}
        <Route element={<Layout />}>
          <Route path="/base" element={<Bases />} />
          <Route path="/admin/base/add" element={<AddBase />} />
          <Route path="/admin/base/edit/:id" element={<EditBase />} />
        </Route>


        <Route index path="/" element={<Login onBack={() => setCurrentView('admin')} />} />
        
        <Route path="/admin/*" element={
          <AdminLayout onSwitchToChawder={() => setCurrentView('chawder')} onGoToLogin={() => setCurrentView('login')} />
        }>
          <Route path="*" element={<AdminRoutes />} />
        </Route>

        <Route element={<Layout />}>
        <Route path="/admin/importers" element={<ExcelImport />} />
        <Route path="/admin/export" element={<FastExcelExport />} />

          <Route path="/admin/log" element={<UserLog />} />
        </Route>
        <Route path="/chawder/*" element={
          <ChawderLayout onSwitchToAdmin={() => setCurrentView('admin')} />
        }>
          <Route path="*" element={<ChawderRoutes />} />
        </Route>
        
        <Route path="*" element={<Navigate to="/admin" replace />} />
      </Routes>
    </Suspense>
  );
}

export default AppRouter;
